"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.presetStyles = void 0;
exports.presetStyles = {
    ["obs-radar.rain.nzl.national"]: {
        type: "wxtilesv3",
        datasetId: "obs-radar.rain.nzl.national",
        variable: "reflectivity",
        styleId: "base",
        styleOverrides: {
            isolineText: false,
            isolineColor: "none",
            colorMap: [
                [0, "rgba(0, 0, 0, 0)"],
                [1, "#929a00"],
                [2, "#b5bc00"],
                [4, "#d9e400"],
                [6, "#fbff66"],
                [8, "#fbff00"],
                [10, "#fdf400"],
                [12, "#fdf000"],
                [14, "#fee000"],
                [16, "#fdcc00"],
                [18, "#ffb400"],
                [20, "#ffa000"],
                [20, "#2e43c2"],
                [23.3, "#3b5ee0"],
                [26.7, "#4f78ff"],
                [30, "#57abff"],
                [30, "#69eaf5"],
                [33.3, "#59d0d8"],
                [36.7, "#48b7ba"],
                [40, "#40a9a7"],
                [40, "#e53800"],
                [45, "#ff4800"],
                [45, "#6f079e"],
                [50, "#c237e3"],
                [50, "#e9e6e9"],
                [55, "#ffffff"],
                [55, "#39b200"],
                [60, "#69fd00"],
                [60, "#d42e93"],
                [66, "#ee37ca"],
                [72, "#ff3fff"],
            ],
            units: "",
        },
        showLegend: false,
        markTitles: [
            [8, "Light"],
            [30, "Moderate"],
            [45, "Heavy"],
            [60, "Hail*"],
        ],
    },
    ["obs-radar.rain.aus.national"]: {
        type: "wxtilesv3",
        datasetId: "obs-radar.rain.aus.national",
        variable: "reflectivity",
        styleId: "base",
        styleOverrides: {
            isolineText: false,
            isolineColor: "none",
            colorMap: [
                [0, "rgba(0, 0, 0, 0)"],
                [4, "#F5F5FF"],
                [8, "#B4B4FF"],
                [12, "#7878FF"],
                [16, "#1414FF"],
                [20, "#00D8C3"],
                [24, "#009690"],
                [28, "#006666"],
                [32, "#FFFF00"],
                [36, "#FFC800"],
                [40, "#FF9600"],
                [44, "#FF6400"],
                [48, "#FF0000"],
                [52, "#C80000"],
                [56, "#780000"],
                [60, "#280000"],
            ],
            units: "☔rate",
        },
        showLegend: false,
        evenlyLabelMarks: true,
        markTitles: [
            [12, "Light"],
            [32, "Moderate"],
            [48, "Heavy"],
        ],
    },
    ["lightning.threat.aus.national"]: {
        type: "wxtilesv3",
        datasetId: "lightning.threat.aus.national",
        variable: "lightning.threat",
        styleId: "base",
        styleOverrides: {
            isolineText: false,
            isolineColor: "none",
            colorMap: [
                [0, "#fdd49f00"],
                [1, "#fdd49fff"],
                [2, "#d7301fff"],
            ],
            units: "⚡risk",
        },
        showLegend: false,
        markTitles: [
            [1, "Medium"],
            [2, "High"],
        ],
        legendColorMap: [
            [0, "#fdd49fff"],
            [1, "#fdd49fff"],
            [1.5, "#fdd49fff"],
            [1.5, "#d7301fff"],
            [2, "#d7301fff"],
            [2.5, "#d7301fff"],
        ],
    },
    ["lightning.threat.nzl.national"]: {
        type: "wxtilesv3",
        datasetId: "lightning.threat.nzl.national",
        variable: "lightning.threat",
        styleId: "base",
        styleOverrides: {
            isolineText: false,
            isolineColor: "none",
            colorMap: [
                [0, "#fdd49f00"],
                [1, "#fdd49fff"],
                [2, "#d7301fff"],
            ],
            units: "⚡risk",
        },
        showLegend: false,
        markTitles: [
            [1, "Medium"],
            [2, "High"],
        ],
        legendColorMap: [
            [0, "#fdd49fff"],
            [1, "#fdd49fff"],
            [1.5, "#fdd49fff"],
            [1.5, "#d7301fff"],
            [2, "#d7301fff"],
            [2.5, "#d7301fff"],
        ],
    },
};
